import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: 'Is this only for Christians?',
  a: "The framework is faith-informed, not denomination-specific. If you believe in something larger than yourself and you're wrestling with a relationship decision — this is for you. The tools work whether you pray daily or you're just spiritually curious."
}, {
  q: 'Is this therapy or counseling?',
  a: 'No. This is an educational toolkit for personal clarity and decision-making. It is not medical or psychological advice. If you are experiencing a clinical condition or safety concern, please seek professional support.'
}, {
  q: "What if my body 'lies' to me?",
  a: "Great question — and we address it directly inside the guide. The Body Check is one filter of three, not the final word. That's why the framework triangulates across Body + Fruit + Timing. No single signal carries all the weight."
}, {
  q: 'How long will it take to get results?',
  a: 'The Pocket Card takes 5 minutes. Most people report feeling significantly clearer after their first pass through all three filters — even before finishing the full guide.'
}, {
  q: "What if I'm in Yellow and I stay there forever?",
  a: "The 72-Hour Rule solves this. Yellow always has a revisit date. It is not permission to avoid indefinitely — it's a structured waiting period with a built-in deadline."
}, {
  q: 'Is this just for women?',
  a: 'The framework works for anyone. The Relationship Edition speaks most directly to women 25–48 navigating loud relationship decisions, but the tools are universal.'
}, {
  q: 'What format is it in?',
  a: 'PDF — instant download. Works on your phone, tablet, or laptop. Print the Pocket Card and Scorecard for daily use.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 md:py-28 px-4 bg-cream watermark-bg" data-id="element-39">
      <div className="max-w-3xl mx-auto" data-id="element-40">
        <div className="text-center mb-12" data-id="element-41">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-42">
            Questions People Ask Before They Buy
          </h2>
        </div>

        <div className="space-y-4" data-id="element-43">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-sm border border-warm-gray overflow-hidden" data-id="element-44">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-45">
                <span className="font-bold text-charcoal pr-4" data-id="element-46">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-gold transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-47" />
              </button>

              <AnimatePresence data-id="element-48">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-49">
                    <div className="px-6 pb-5 text-charcoal/80 leading-relaxed border-t border-warm-gray pt-4" data-id="element-50">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}